export default {"src":"/_next/static/media/LoginImg2.cc57ea78.svg","height":905,"width":904,"blurWidth":0,"blurHeight":0};